import axios from 'axios';
import store from './store';
import {loadingDecrement, loadingIncrement} from "./actions/CommonActions";
import {setIsLoggedIn} from "./actions/UserActions";

const instance = axios.create({});
let token = sessionStorage.getItem('token');
instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;

function handleErrors(e) {
  if(typeof e.response === "undefined"){
    // Network error, no response came back.
    loadingDecrement(store.dispatch);
    return;
  }
  if (e.response.status === 401) {
    if (e.response.data && e.response.data.reason === 'not_logged_in') {
      store.dispatch(setIsLoggedIn(false));
    }
  }
  loadingDecrement(store.dispatch);
}

export default {

  get: (url, config) => {
    loadingIncrement(store.dispatch);
    return axios.get(url, config).then(response => {
      loadingDecrement(store.dispatch);
      return response;
    }).catch((e) => {
      handleErrors(e);
      throw e;
    });
  },

  post: (url, data, config = {}) => {
    loadingIncrement(store.dispatch);
    return axios.post(url, data, config).then(response => {
      loadingDecrement(store.dispatch);
      return response;
    }).catch((e) => {
      handleErrors(e);
      throw e;
    });
  },

  put: (url, data) => {
    loadingIncrement(store.dispatch);
    return axios.put(url, data).then(response => {
      loadingDecrement(store.dispatch);
      return response;
    }).catch((e) => {
      handleErrors(e);
      throw e;
    });
  },

  delete: (url, config) => {
    loadingIncrement(store.dispatch);
    return axios.delete(url, config).then(response => {
      loadingDecrement(store.dispatch);
      return response;
    }).catch((e) => {
      handleErrors(e);
      throw e;
    });
  },

  instance: instance

};
